module.exports = __webpack_public_path__ + "static/img/pic-03@2x.5dec1b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/pic-03@2x.png
// module id = DgEf
// module chunks = 1